import { useTranslation } from 'next-i18next'

const DigitalClock = ({
  minutes,
  hours,
  version,
  className,
}: {
  minutes: number
  hours: number
  version?: 'AM' | 'PM'
  className: string
}): React.ReactElement => {
  const { t } = useTranslation('mathVault')
  return (
    <div aria-label={t('digitalClock', { hours, minutes, version })} className={`${className}`} role="img">
      <div className="bg-pink-500 border-2 border-gray-footer rounded-small p-1">
        <div className="bg-white border-2 rounded-small border-gray-footer flex gap-1 justify-center text-base sm:text-2xl font-bold p-2 text-gray-footer">
          <span>{(hours % 24).toString().padStart(2, '0')}</span>
          <span>:</span>
          <span>{(minutes % 60).toString().padStart(2, '0')}</span>
          {version && (
            <span className="flex flex-col text-xs font-normal leading-3">
              {version.split('').map((c, i) => (
                <span key={i}>{c}</span>
              ))}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default DigitalClock
